const initialState = {};

const appReducer = (state = initialState, { type, data }) => {
  switch (type) {
    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/reducers/appReducer.js